import { selectQuestionnaireAsQuestionnaireConfigFactory } from "../../questionnaireConfig";
import { PHYSIOTHERAPY_MGR_REFERRAL_QUESTIONNAIRE_KEY, PHYSIOTHERAPY_SELF_REFERRAL_QUESTIONNAIRE_KEY } from "../../../physiotherapy/models";

export const selectPhysiotherapyMgrReferralQuestionnaireAsQuestionnaireConfig =
    selectQuestionnaireAsQuestionnaireConfigFactory(PHYSIOTHERAPY_MGR_REFERRAL_QUESTIONNAIRE_KEY);

export const selectPhysiotherapySelfReferralQuestionnaireAsQuestionnaireConfig =
    selectQuestionnaireAsQuestionnaireConfigFactory(PHYSIOTHERAPY_SELF_REFERRAL_QUESTIONNAIRE_KEY);
